import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';
import classnames from 'classnames';
import React from 'react';

import { withStyles } from '../../styles/tools';
import { withTrace } from '../../utils/trace';
import { styles } from './EmptyState.styles';
import type { EmptyStateAllProps, EmptyStateProps } from './EmptyState.types';

export function EmptyStateBase({
    classes,
    children,
    image,
    title,
    message,
    variant = 'large',
    applyTrace,
}: EmptyStateAllProps) {
    const isSmall = variant === 'small';

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            className={classes.root}
            {...applyTrace()}
        >
            {image && (
                <Grid item xs={12} {...applyTrace('image')}>
                    {image}
                </Grid>
            )}
            <Grid item xs={12} sm={isSmall ? 10 : 6} md={isSmall ? 10 : 4} className={classes.body}>
                <Typography
                    className={classnames(classes.title, { [classes.smallTitle]: isSmall })}
                    {...applyTrace('title')}
                >
                    {title}
                </Typography>
                <Typography className={classes.message} {...applyTrace('message')}>
                    {message}
                </Typography>
                {children && <Grid {...applyTrace('children')}>{children}</Grid>}
            </Grid>
        </Grid>
    );
}

const tracedComponent = withTrace('empty-state')<EmptyStateProps>(EmptyStateBase);
export const EmptyState = withStyles(styles)(tracedComponent);
export default EmptyState;
